import React, { useEffect, useCallback, useState } from 'react';
import { Box, Button } from '@material-ui/core';

import { sessionQuery } from '@lib/state';
import { useObservable, usePageTitle, Section } from '@lib/common';
import { EmployeeList, EmployeeSearchFilter, AddEmployeeModal } from './../components';
import { Tile } from 'app/shared';
import { employeeService, employeeQuery, EmployeeFilters } from 'app/state';

export const UserManagementPage: React.FC = () => {
  const propertyId = useObservable(sessionQuery.propertyId, 'async');
  const employees = useObservable(employeeQuery.employees, 'async');
  const [employeeFilters, setEmployeeFilters] = useState<EmployeeFilters>({
    propertyId: propertyId ?? '',
  });

  const [openAddEmployeeModal, setOpenAddEmployeeModal] = useState(false);

  const onCloseOpenAddEmployeeModal = useCallback(() => {
    setOpenAddEmployeeModal(false);
  }, []);

  usePageTitle('User Management');

  useEffect(() => {
    if (propertyId) setEmployeeFilters(e => ({ ...e, propertyId }));
  }, [propertyId]);

  useEffect(() => {
    if (employeeFilters.propertyId.length > 0) {
      employeeService.getEmployees(employeeFilters);
    }
  }, [employeeFilters]);

  const showAddEmployeeModal = () => {
    setOpenAddEmployeeModal(true);
  };

  return (
    <Section>
      <Tile>
        <Box display="flex" justifyContent="flex-end" flexDirection="row">
          <Button color="secondary" variant="contained" onClick={showAddEmployeeModal}>
            Add Employee
          </Button>
        </Box>
        <EmployeeSearchFilter filters={employeeFilters} onChange={setEmployeeFilters} />

        {employees && employees.length > 0 && !!propertyId && (
          <Section title="Results" textAlign="left" disableGutters>
            <EmployeeList employees={employees} />
          </Section>
        )}

        <AddEmployeeModal open={openAddEmployeeModal} onClose={onCloseOpenAddEmployeeModal} />
      </Tile>
    </Section>
  );
};
